export default __webpack_public_path__ + "static/media/Live-Tour.f25ddb88.png";